var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-card-title',{class:_vm._class,attrs:{"..._attributes":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }